import { setLocale } from 'yup'
import i18next from '../../Services/localize/i18n'

const initial = () => {
    setLocale({
        mixed: {
            required: ({ label, path }) => {
                return i18next.t('form.required', { path: label || path })
            },
            notType({ label, path }) {
                return i18next.t('form.required', { path: label || path })
            },
        },
    })
}

export default initial
